import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { usePageTitle } from '../../config';
import UsersDashboard from './UsersDashboard/UsersDashboard';
import { useRoles } from 'src/provider/UserRoleProvider';
import { ErrorPage } from '@im/ui-lib/ErrorPage';
import { NestedApiLocalizationProvider } from 'src/provider/LocalizationProviderConnector';
import { useTranslate } from '@im/react-localization';

export function UsersRoute() {
  const { updatePageTitle } = usePageTitle();
  const translate = useTranslate();
  updatePageTitle(translate('UserRoles.PageTitle'));
  const { isSuperAdminUser } = useRoles();

  return (
    <NestedApiLocalizationProvider preloadResources={['UserRoles', 'Common']}>
      {isSuperAdminUser ? (
        <Routes>
          <Route element={<Navigate replace to="users-dashboard" />} path="" />
          <Route element={<UsersDashboard />} path="users-dashboard" />
        </Routes>
      ) : (
        <Routes>
          <Route
            element={
              <ErrorPage
                data-testid="gds-vp-access-denied-page"
                errorCode="403"
                errorText="You don't have access to this page. Please get access before you try again."
                message="Access Denied"
                showHomeButton
              />
            }
            path="*"
          />
        </Routes>
      )}
    </NestedApiLocalizationProvider>
  );
}
